import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const ChevronLeft: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <polygon
      transform="translate(8.363636, 8.000000) rotate(-180.000000) translate(-8.363636, -8.000000) "
      points="4 14.1194557 9.39441967 8 4 1.87971331 5.66137558 2.64758027e-15 12.7272727 8 5.66137558 16"
    ></polygon>
  </Icon>
);
